import React, {ReactElement} from 'react';

import Tooltip from 'src/components/tooltip';

const NewTabTooltip = ({children}: React.PropsWithChildren) => (
  <Tooltip title="Opens in new tab">{children as ReactElement}</Tooltip>
);

export default NewTabTooltip;
